(function ($) {
    "use strict";

    // START MENU JS
    $(window).on("scroll", function () {
        if ($(this).scrollTop() > 50) {
            $(".main-nav").addClass("menu-shrink");
        } else {
            $(".main-nav").removeClass("menu-shrink");
        }
    });

    $(".owl-carousel").owlCarousel({
        loop: false,
        margin: 20,
        items: 3,
        autoplay: true,
        nav: false,
        dotsEach: false,
        dots: false,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 3,
            },
            600: {
                items: 3,
            },
            1000: {
                items: 3,
            },
        },
    });

    // Mean Menu
    jQuery(".mean-menu").meanmenu({
        meanScreenWidth: "991",
    });

    // Sorting Portfolio JS
    try {
        var mixer = mixitup("#container", {
            controls: {
                toggleDefault: "none",
            },
        });
    } catch (err) {}

    // Nice Select JS
    // $('select').niceSelect('update');

    // Companies Slider JS
    $(".companies-slider").owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        dots: true,
        items: 3,
        smartSpeed: 1000,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 2,
            },
            1000: {
                items: 3,
            },
        },
    });

    // Profile Slider JS
    $(".profile-slider").owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        dots: true,
        items: 3,
        smartSpeed: 1000,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 2,
            },
            1000: {
                items: 4,
            },
        },
    });

    // Wow JS
    new WOW().init();

    // Accordion JS
    // Initialisation: ouvre le premier élément de chaque accordéon
    $(".accordion > li:eq(0) a").addClass("active");
    $(".accordion > li:eq(0) div.faq-content").slideDown();
    $(".accordion > li:eq(0) table").show();
    
    // Gestion des clics sur les éléments d'accordéon
    $(".accordion a").on("click", function (j) {
        j.preventDefault(); // Empêche le comportement par défaut du lien
        
        var $this = $(this);
        var $li = $this.closest("li");
        var dropDown = $li.find("div.faq-content, table"); // Sélectionne à la fois div.faq-content et table
        var $accordion = $this.closest(".accordion");
        
        // Ferme tous les autres éléments ouverts dans cet accordéon
        $accordion.find("div.faq-content, table").not(dropDown).slideUp(300);
        
        // Gestion de l'état actif/inactif
        if ($this.hasClass("active")) {
            // Si déjà actif, désactive et ferme
            $this.removeClass("active");
            dropDown.slideUp(300);
        } else {
            // Sinon, désactive tous les autres et active celui-ci
            $accordion.find("a.active").removeClass("active");
            $this.addClass("active");
            dropDown.slideDown(300);
        }
    });
    

    // Back to top
    $("body").append(
        '<div id="toTop" class="back-to-top-btn"><i class="icofont-dotted-up"></i></div>'
    );
    $(window).scroll(function () {
        if ($(this).scrollTop() != 0) {
            $("#toTop").fadeIn();
        } else {
            $("#toTop").fadeOut();
        }
    });
    $("#toTop").on("click", function () {
        $("html, body").animate({ scrollTop: 0 }, 900);
        return false;
    });
})(jQuery);
